var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',_vm._l((_vm.hotpaths),function(fn,idx){return _c('div',{key:idx},[_c('SingleFunctionCard',{attrs:{"data-v-demo-fn":idx,"fn":fn}})],1)}))}
var staticRenderFns = []

export { render, staticRenderFns }